export default __webpack_public_path__ + "static/media/main-logo-en.8ff0207e.svg";